import { isNumber, isString } from '@mbrtargeting/metatag-utils';

/**
 * replaces placeholders in a "given" template string, based on passed object "placeholders".<br>
 * Placeholders in template string should be in format #{PLACEHOLDER}
 * @param template
 * @param placeholders
 * @example https://www.mydomain.de?id=#{MyPlaceHolderName}
 */
export const renderTemplate = (template: string = '', placeholders: Record<string, string | number> = {}): string => {
    return template.replace(/#{([^{}]*)}/gi, (_completeMatch, placeholderName) => {
        const placeholderValue = placeholders[placeholderName];
        return (isNumber(placeholderValue) || isString(placeholderValue)) ? String(placeholderValue) : '';
    });
};
